import { useState, useEffect } from "react";
import useFetchCsrfToken from "../0. Utilidades/useFetchCsrfToken";

const useAsistenciaLogic = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [cursos, setCursos] = useState([]);
  const [selectedCurso, setSelectedCurso] = useState(null);
  const [selectedMaestras, setSelectedMaestras] = useState([]);
  const [fecha, setFecha] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const csrfToken = useFetchCsrfToken();
  const [editingAsistencia, setEditingAsistencia] = useState(null);

  useEffect(() => {
    fetchCursos();
  }, []);

  const fetchCursos = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API}api/perfiles/cursos/?now=true`,
      );
      const data = await response.json();
      setCursos(data);
    } catch (error) {
      console.error("Error fetching cursos:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCursoClick = (curso) => {
    setSelectedCurso(curso);
    setFecha("");
    setSelectedMaestras([]);
  };

  const handleMaestraToggle = (rut) => {
    setSelectedMaestras((prev) =>
      prev.includes(rut) ? prev.filter((id) => id !== rut) : [...prev, rut],
    );
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    const method = editingAsistencia ? "PATCH" : "POST";
    const url = editingAsistencia
      ? `${process.env.REACT_APP_BASE_API}api/asistencia/asistencias/${editingAsistencia.id}/`
      : `${process.env.REACT_APP_BASE_API}api/asistencia/asistencias/`;

    try {
      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": csrfToken,
        },
        body: JSON.stringify({
          curso: selectedCurso.id,
          fecha,
          maestras_asistentes: selectedMaestras,
        }),
        credentials: "include",
      });

      if (response.ok) {
        setShowSuccessAlert(true);
        setTimeout(() => setShowSuccessAlert(false), 4000);
        setSelectedCurso(null);
        setSelectedMaestras([]);
        setFecha("");
        setEditingAsistencia(null);
      }
    } catch (error) {
      console.error("Error submitting asistencia:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const formatToISO = (dateStr) => {
    const [day, month, year] = dateStr.split("-");
    return `${year}-${month}-${day}`;
  };

  const handleCloseModal = () => {
    setIsOpen(false);
    setSelectedCurso(null);
    setSelectedMaestras([]);
    setFecha("");
    setShowSuccessAlert(false);
    setEditingAsistencia(null); // ✅ Reset edit state
  };

  return {
    isOpen,
    setIsOpen,
    cursos,
    selectedCurso,
    setSelectedCurso,
    fecha,
    selectedMaestras,
    isLoading,
    showSuccessAlert,
    handleCursoClick,
    handleSubmit,
    handleMaestraToggle,
    formatToISO,
    setFecha,
    handleCloseModal,
    setSelectedMaestras,
    editingAsistencia,
    setEditingAsistencia,
  };
};

export default useAsistenciaLogic;
